module.exports = __webpack_public_path__ + "img/2-3-cofinanciado-por-el-programa-europa-creativa-de-la-union-europea.99f3f151.jpg";